import React from 'react';
import GoogleMapReact from 'google-map-react';

const googleMapOptions = {
  styles: [
    {
      'featureType': 'all',
      'elementType': 'all',
      'stylers': [
        {
          'hue': '#ffaa00',
        },
        {
          'saturation': '-33',
        },
        {
          'lightness': '10',
        },
      ],
    },
    {
      'featureType': 'administrative.locality',
      'elementType': 'labels.text.fill',
      'stylers': [
        {
          'color': '#9c5e18',
        },
      ],
    },
    {
      'featureType': 'landscape.natural.terrain',
      'elementType': 'geometry',
      'stylers': [
        {
          'visibility': 'simplified',
        },
      ],
    },
    {
      'featureType': 'road.highway',
      'elementType': 'geometry',
      'stylers': [
        {
          'visibility': 'simplified',
        },
      ],
    },
    {
      'featureType': 'road.highway',
      'elementType': 'labels.text',
      'stylers': [
        {
          'visibility': 'on',
        },
      ],
    },
    {
      'featureType': 'road.arterial',
      'elementType': 'geometry',
      'stylers': [
        {
          'visibility': 'simplified',
        },
      ],
    },
    {
      'featureType': 'transit.line',
      'elementType': 'all',
      'stylers': [
        {
          'visibility': 'off',
        },
      ],
    },
    {
      'featureType': 'water',
      'elementType': 'geometry.fill',
      'stylers': [
        {
          'saturation': '-23',
        },
        {
          'gamma': '2.01',
        },
        {
          'color': '#f2f6f6',
        },
      ],
    },
    {
      'featureType': 'water',
      'elementType': 'geometry.stroke',
      'stylers': [
        {
          'saturation': '-14',
        },
      ],
    },
  ],
};

const AizulabMap = React.memo(({ children, onChildMouseEnter, onChildMouseLeave }) => {
  return (
    <GoogleMapReact
      onChildMouseEnter={enterKey => onChildMouseEnter(enterKey)}
      onChildMouseLeave={leaveKey => onChildMouseLeave(leaveKey)}
      bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLEMAP_ACCESSKEY }}
      defaultCenter={{
        lat: 37.505000,
        lng: 139.922941,
      }}
      defaultZoom={12}
      options={googleMapOptions}
    >
      {children}
    </GoogleMapReact>
  );
});

export default AizulabMap;